import React, { useCallback, useState } from 'react';
import cn from 'classnames';
import Editor from '../../Editor';
import { EditorProps } from '../../types';
import { extConfig } from './config';
import PluginInsertMenu from '../../../menus/PluginInsertMenu';

import s from './OriginalsQuestion.scss';

const OriginalsQuestion: React.FC<
  Omit<EditorProps, 'extensionConfig' | 'presetId' | 'onFocus' | 'onBlur'>
> = props => {
  const [isExpanded, setIsExpanded] = useState(false);
  const onFocus = useCallback(() => {
    setIsExpanded(true);
  }, []);

  return (
    <div className={cn(s['root'], isExpanded && s['expanded'])}>
      <Editor
        {...props}
        onFocus={onFocus}
        withinModal
        presetId="originals-question"
        extensionConfig={extConfig}
        className={s['editor']}
      ></Editor>
      <div className={s['toolbar']}>
        <PluginInsertMenu />
      </div>
    </div>
  );
};

export default OriginalsQuestion;
